<template>
  <div class="container-warp">
    <Top-Nav pageTitle="已参加考试" @click-left="pageBack"></Top-Nav>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="onLoad">
      <van-cell-group inset v-for="item in list" :key="item.id" class="list-item">
        <div class="list-item-hd">
          <span>{{ item.examName }}</span>
          <span :class="handleGradesClassName(item)">成绩：{{ item.stuScore || '0' }} / {{ item.examScore || '0' }}</span>
        </div>
        <div class="list-item-bd">
          <p>考试类别：{{ item.examTypeNm }}</p>
          <p>考试时间：{{ item.examTimeStart }}至{{ item.examTimeEnd }}</p>
          <p>交卷时间：<span class="text-primary">{{ item.endTime }}</span></p>
        </div>
        <div class="list-item-foot">
          <van-button type="info" size="small" @click="jumpViewExam(item)" icon="description-o">查看试卷</van-button>
        </div>
      </van-cell-group>
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { chooseExamPaper, findEndExam } from "@/api/exam.js";
export default {
  name: 'AlreadyExam',
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 20,
    }
  },
  computed: {
    ...mapGetters(["userCode"]),
    handleGradesClassName() {
      return function (row) {
        const { stuScore = 0, passScore = 0 } = row
        if (Number(stuScore) >= Number(passScore)) {
          return 'text-green'
        } else {
          return 'text-danger'
        }
      }
    }
  },
  created() {
    this.handleChooseExamPaper()
  },
  methods: {
    async handleChooseExamPaper() {
      const params = { stuId: this.userCode }
      const { status } = await chooseExamPaper(params);
      if (status == 200) {
        this.onLoad()
      }
    },
    async onLoad() {
      const params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        stuId: this.userCode,
        examMode: 0
      }
      // console.log(params)
      const { status, data } = await findEndExam(params);
      if (status == 200) {
        let records = data.list || [];
        this.list.push(...records)
        this.total = data.total;
        this.pageNum++;
        // 数据全部加载完成
        if (this.list.length >= this.total) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        // 加载状态结束
        this.loading = false;
      }
    },
    // 开始考试页面
    jumpViewExam(row) {
      // if (!row.endTime) {
      //   this.$toast('不能查看未交卷的考试！')
      //   return
      // }
      this.$router.push({ path: '/viewExam', query: { examStuId: row.examStuId } })
    },
    pageBack() {
      this.$router.push({ path: '/index' })
    },
  },
}
</script>

<style lang="less" scoped>
@import url("~@/assets/css/list-style.less");

.list-item {
  .list-item-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
  }

  .list-item-foot {
    display: flex;
    justify-content: center;
  }
}
</style>
